import React from "react";
import { Link } from "react-router-dom";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { BookButton } from "@/components/ui-bits";
import { ROOMS, IMAGES } from "@/lib/site";

export default function Rooms() {
  return (
    <>
      <Seo
        title="Rooms & Suites | Regency Inn & Suites, Pittsburg KS"
        description="Explore clean, comfortable rooms and extended-stay suites at Regency Inn & Suites in Pittsburg, Kansas — king rooms, two-queen family rooms, kitchenette suites and accessible rooms."
        path="/rooms"
        schema={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Rooms", path: "/rooms" }])]}
      />
      <PageHero
        eyebrow="Accommodations"
        title="Rooms made for real stays."
        subtitle="Whether it's one night or one season, every room is clean, quiet and thoughtfully equipped — with parking right outside your door."
        image={IMAGES.roomReal1}
        crumbs={[{ name: "Home", path: "/" }, { name: "Rooms", path: "/rooms" }]}
      />
      <section className="bg-bone py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 space-y-24">
          {ROOMS.map((r, i) => (
            <Reveal key={r.slug}>
              <div className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
                <Link to={`/rooms/${r.slug}`} className="img-zoom aspect-[4/3] rounded-md [direction:ltr]" data-testid={`room-img-${r.slug}`}>
                  <img src={r.images[0]} alt={r.name} className="w-full h-full object-cover" loading="lazy" />
                </Link>
                <div className="[direction:ltr]">
                  <span className="text-xs uppercase tracking-[0.25em] text-amber-deep">{r.tagline}</span>
                  <h2 className="font-serif text-4xl md:text-5xl text-forest mt-3">{r.name}</h2>
                  <div className="flex flex-wrap gap-x-8 gap-y-2 mt-5 text-sm text-stone">
                    <span>{r.beds}</span>
                    <span>Sleeps {r.sleeps}</span>
                    <span>{r.size}</span>
                  </div>
                  <p className="mt-5 text-stone leading-relaxed">{r.description}</p>
                  <div className="mt-7 flex flex-wrap gap-4">
                    <Link
                      to={`/rooms/${r.slug}`}
                      data-testid={`room-detail-${r.slug}`}
                      className="inline-flex rounded-full bg-forest text-bone px-7 py-3.5 text-sm font-medium hover:bg-amber transition-colors"
                    >
                      View Room
                    </Link>
                    <BookButton label="Check Availability" variant="ghost" testid={`room-book-${r.slug}`} className="text-forest" />
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
